export const throttle = <F extends (...args: any) => void>(
  func: F,
  wait = 0,
  {
    leading = true,
    trailing = true,
  }: { readonly leading?: boolean; readonly trailing?: boolean } = {},
) => {
  const {
    call,
    isIdle: _isIdle,
    ...rest
  } = R_funnel(
    () => {
      if (leading || trailing) {
        func()
      }
    },
    {
      maxBurstDurationMs: wait,
      triggerAt: 'start',
    },
  )
  return Object.assign(call, rest)
}
